import { render } from "./ArmManagement.vue?vue&type=template&id=7522c450&scoped=true"
import script from "./ArmManagement.js?vue&type=script&lang=js"
export * from "./ArmManagement.js?vue&type=script&lang=js"

import "./ArmManagement.vue?vue&type=style&index=0&id=7522c450&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7522c450"]])

export default __exports__